import { render, staticRenderFns } from "./PointProgramEditActivePrograms.vue?vue&type=template&id=e59055f4&"
import script from "./PointProgramEditActivePrograms.vue?vue&type=script&lang=js&"
export * from "./PointProgramEditActivePrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports